import { trackInternalEvent } from '@rio/tracking'
import { Resume } from 'packages/types'
import { LayoutFormatChangeHandler } from 'builder/modules/resumeEditor'
import { SelectValue } from '../../../../Select/types'
import { useTemplateCustomization } from './useTemplateCustomization'

export function usePageFormatCustomisation(
  resume?: Resume,
  onFieldChange?: LayoutFormatChangeHandler,
) {
  const { letterFormatOptions, supportsLayoutFormats, selectedLayoutFormatOption, templateName } =
    useTemplateCustomization(resume)
  const handlePageSizeSelectionClick = () => {
    trackInternalEvent('click_resume_page_size_menu', {
      template: templateName,
    })
  }
  return {
    letterFormatOptions,
    supportsLayoutFormats,
    selectedLayoutFormatOption,
    onButtonClick: handlePageSizeSelectionClick,
    onSelect: (value: SelectValue) => {
      if (onFieldChange) {
        onFieldChange(value)
      }
    },
  }
}
